export const appRoutes = {
  /*
   * Authentication
   */
  auth: '/auth',
  authSignIn: '/sign-in',
  authSignInWithMagicLink: '/in',
  authSignInSendMagicLink: '/magic-link',
  authSignInConfirmSendMagicLink: '/continue-to-magic-link',
  authSignInUnsupported: '/unsupported',
  authSignUp: '/sign-up',
  authSignUpSetupPassword: '/sign-up/create-password',
  authSignUpConfirmData: '/sign-up/confirm',
  authForgotPassword: '/forgot-password',
  authResetPassword: '/reset-password',
  authConfirmSignUp: '/confirm-sign-up',

  /*
   * Onboarding
   */
  getStarted: '/get-started',

  /*
   * GameWrapper
   */
  gameWrapper: '/game-wrapper',

  /*
   * Home
   */
  home: '/',

  /*
   * Onboarding
   */
  onboarding: '/get-started',

  /*
   * Profile
   */
  profile: '/profile',
  profileOverview: '/profile/overview',
  profileSecurity: '/profile/security',
  profileSettings: '/profile/settings',
  profileReferrals: '/profile/referrals',
  profileSubscriptions: '/profile/subscriptions',
  profilePreferences: '/profile/preferences',
  profileTaxForm: '/profile/tax-form',
  profileIdentity: '/profile/identity',
  profilePrizes: '/profile/prizes',
  profilePromoCodes: '/profile/promo-codes',

  /*
   * Profit
   */
  profit: '/profit',

  /*
   * Tournaments
   */
  tournaments: '/tournaments',
  tournamentDetails: '/tournaments/:type/:tournamentUrl',
  tournamentEventDetails:
    '/tournaments/:type/:tournamentUrl/:eventScheduleUuid',

  /*
   * Wallet
   */
  wallet: '/wallet',
  walletDeposit: '/wallet/deposit',
  walletWithdraw: '/wallet/withdraw',
  walletWithdrawComplete: '/wallet/withdraw/complete',
  walletHistory: '/wallet/history',

  /*
   * User Game Profile
   */
  userGameProfile: '/user-game-profile',
};
